import { API_ENDPOINT } from '../constants';
import { HTTP } from '../services/http.service';

export const UsersService = {
  saveUser: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users`, data);
  },
  editUser: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users`, data);
  },
  getAdminsForCompany: (account: string) => {
    return HTTP.get<any>(`${API_ENDPOINT.CORE}users/company-admins/${account}`);
  },
  getUsersForAccount: (account: string) => {
    return HTTP.get<any>(`${API_ENDPOINT.CORE}users/${account}`);
  },
  getUsers: () => {
    return HTTP.get<any>(`${API_ENDPOINT.CORE}users`);
  },
  recoverPassworUsers: (user: { user: string }) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/reset-password`, user);
  },
  recoverPassword: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/change-password`, data);
  },
  changeStatus: (data: any, type: string) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/${type}`, data);
  },
  deleteUser: (user: any) => {
    const data = { user };
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}users`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    });
  }
};
